import LoadingComponent from 'Components/HelperComponents/LoadingComponent'
import { useAccreditacioEntities } from 'hooks/useAccreditacioEntities'
import PerformingEntityAccreditationsForm from 'NewVersion/pages/Acreditacions/PerformingEntityAccreditationsForm'
import { GoBackButton } from 'NewVersion/components/UI/GoBack/GoBackButton'
import 'NewVersion/styles/Acreditacions.scss'
import { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import {
  ACCOUNT_PATH,
  PAYMENT,
  REGISTER_ENTITY_PATH,
  REGISTER_ENTITY_PERFORMING_SELECT_PATH,
} from 'Routes/Paths'
import { ACCREDITATION_TYPE } from 'utils/constants'
import { matchesEntityRouteId } from './utils'

const PerformingFormPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { entityId } = useParams()
  const {
    performing,
    accreditationCase,
    loading: loadingEntities,
    error,
  } = useAccreditacioEntities()

  const selectedEntity = useMemo(() => {
    return performing.find((entity) => matchesEntityRouteId(entity, entityId))
  }, [entityId, performing])

  useEffect(() => {
    if (loadingEntities || error) {
      return
    }

    if (accreditationCase !== ACCREDITATION_TYPE.performing) {
      navigate(REGISTER_ENTITY_PATH, { replace: true })
      return
    }

    if (!selectedEntity) {
      navigate(REGISTER_ENTITY_PERFORMING_SELECT_PATH, { replace: true })
    }
  }, [accreditationCase, error, loadingEntities, navigate, selectedEntity])

  if (loadingEntities) {
    return <LoadingComponent />
  }

  if (error) {
    return (
      <div className="acreditacions page-wrapper">
        <h1>{t('acreditacions')}</h1>
        <p>
          {t('error_loading_accreditation', 'An error occurred loading your accreditation data')}
        </p>
      </div>
    )
  }

  if (accreditationCase !== ACCREDITATION_TYPE.performing || !selectedEntity) {
    return <LoadingComponent />
  }

  return (
    <div className="acreditacions page-wrapper">
      <GoBackButton
        text={t('Tornar a acreditacions')}
        dataTest="acreditacionsPerformingFormBack"
        onClick={() => navigate(REGISTER_ENTITY_PERFORMING_SELECT_PATH)}
      />
      <h1 className="acreditacions-perform-form-title">
        {selectedEntity.title || t('entity_professional_title')}
      </h1>
      <PerformingEntityAccreditationsForm
        entityId={entityId}
        onWarningCancel={() => navigate(REGISTER_ENTITY_PERFORMING_SELECT_PATH)}
        onSubmit={(paymentUuid) => {
          if (paymentUuid) {
            navigate(`${PAYMENT}/info/${paymentUuid}`)
            return
          }
          navigate(ACCOUNT_PATH)
        }}
      />
    </div>
  )
}

export default PerformingFormPage
